// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc, TradePartnerContactFragmentDoc, TradePartnerFragmentDoc, HistoryFeedInfoFragmentDoc, ChangeEventTypeFragmentDoc } from '../../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignPackageRequiredOptionsPageQueryVariables = Types.Exact<{
  designPackageId: Types.Scalars['ID']['input'];
  designPackageVersionId: Types.Scalars['ID']['input'];
}>;


export type DesignPackageRequiredOptionsPageQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, name: string, requiredOptions: Array<{ __typename?: 'ReadyPlanRequiredOption', id: string, active: boolean, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number }>, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, planAddOns: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, availableTargetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number }> } };

export type DesignPackageRequiredOptionsPage_DesignPackageFragment = { __typename?: 'DesignPackage', id: string, name: string, requiredOptions: Array<{ __typename?: 'ReadyPlanRequiredOption', id: string, active: boolean, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number }>, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, planAddOns: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, availableTargetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number }> };

export type DesignPackageRequiredOptionsPage_AddOnsQueryVariables = Types.Exact<{
  designPackageId: Types.Scalars['ID']['input'];
  designPackageVersionId: Types.Scalars['ID']['input'];
}>;


export type DesignPackageRequiredOptionsPage_AddOnsQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, potentialAddOnOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, readyPlan: { __typename?: 'ReadyPlan', id: string, code?: string | null | undefined, name: string } }> } };

export type DesignPackageRequiredOptionsPage_CombinationsQueryVariables = Types.Exact<{
  dpId: Types.Scalars['ID']['input'];
  rpavId: Types.Scalars['ID']['input'];
  targetGroupIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type DesignPackageRequiredOptionsPage_CombinationsQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, combinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> } };

export type SaveDesignPackageRequiredOptionsMutationVariables = Types.Exact<{
  input: Array<Types.SaveReadyPlanRequiredOptionInput> | Types.SaveReadyPlanRequiredOptionInput;
}>;


export type SaveDesignPackageRequiredOptionsMutation = { __typename?: 'Mutation', saveReadyPlanRequiredOptions: { __typename?: 'SaveReadyPlanRequiredOptionsResult', readyPlanRequiredOptions: Array<{ __typename?: 'ReadyPlanRequiredOption', id: string, readyPlan: { __typename?: 'ReadyPlan', id: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } } | { __typename?: 'PlanPackage', id: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } } | { __typename?: 'DesignPackage', id: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } } | { __typename?: 'ProductOffering', id: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string } } }> } };

export type DesignPackageRequiredOptionsPage_TargetGroupsFragment = { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number };

export type DesignPackageRequiredOptionsPage_AddOnsFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, code: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, readyPlan: { __typename?: 'ReadyPlan', id: string, code?: string | null | undefined, name: string } };

export type DesignPackageRequiredOptionsPage_CombinationsFragment = { __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> };

export const DesignPackageRequiredOptionsPage_TargetGroupsFragmentDoc = gql`
    fragment DesignPackageRequiredOptionsPage_TargetGroups on ReadyPlanOptionGroup {
  id
  name
  order
}
    `;
export const DesignPackageRequiredOptionsPage_CombinationsFragmentDoc = gql`
    fragment DesignPackageRequiredOptionsPage_Combinations on DesignPackageOptionCombination {
  id
  name
  options {
    id
  }
}
    `;
export const DesignPackageRequiredOptionsPage_DesignPackageFragmentDoc = gql`
    fragment DesignPackageRequiredOptionsPage_DesignPackage on DesignPackage {
  id
  name
  requiredOptions {
    id
    active
    targetGroups {
      ...DesignPackageRequiredOptionsPage_TargetGroups
    }
    targetCombinations {
      ...DesignPackageRequiredOptionsPage_Combinations
    }
    planAddOns {
      id
    }
  }
  canEdit {
    ...PotentialOperationDetails
  }
  availableTargetGroups {
    ...DesignPackageRequiredOptionsPage_TargetGroups
  }
}
    ${DesignPackageRequiredOptionsPage_TargetGroupsFragmentDoc}
${DesignPackageRequiredOptionsPage_CombinationsFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const DesignPackageRequiredOptionsPage_AddOnsFragmentDoc = gql`
    fragment DesignPackageRequiredOptionsPage_AddOns on ReadyPlanOption {
  id
  name
  code
  location {
    id
    name
  }
  readyPlan {
    id
    code
    name
  }
}
    `;
export const DesignPackageRequiredOptionsPageDocument = gql`
    query DesignPackageRequiredOptionsPage($designPackageId: ID!, $designPackageVersionId: ID!) {
  designPackage(id: $designPackageId, versionId: $designPackageVersionId) {
    ...DesignPackageRequiredOptionsPage_DesignPackage
  }
}
    ${DesignPackageRequiredOptionsPage_DesignPackageFragmentDoc}`;

/**
 * __useDesignPackageRequiredOptionsPageQuery__
 *
 * To run a query within a React component, call `useDesignPackageRequiredOptionsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageRequiredOptionsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageRequiredOptionsPageQuery({
 *   variables: {
 *      designPackageId: // value for 'designPackageId'
 *      designPackageVersionId: // value for 'designPackageVersionId'
 *   },
 * });
 */
export function useDesignPackageRequiredOptionsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageRequiredOptionsPageQuery, DesignPackageRequiredOptionsPageQueryVariables> & ({ variables: DesignPackageRequiredOptionsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageRequiredOptionsPageQuery, DesignPackageRequiredOptionsPageQueryVariables>(DesignPackageRequiredOptionsPageDocument, options);
      }
export function useDesignPackageRequiredOptionsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageRequiredOptionsPageQuery, DesignPackageRequiredOptionsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageRequiredOptionsPageQuery, DesignPackageRequiredOptionsPageQueryVariables>(DesignPackageRequiredOptionsPageDocument, options);
        }
export function useDesignPackageRequiredOptionsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageRequiredOptionsPageQuery, DesignPackageRequiredOptionsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageRequiredOptionsPageQuery, DesignPackageRequiredOptionsPageQueryVariables>(DesignPackageRequiredOptionsPageDocument, options);
        }
export type DesignPackageRequiredOptionsPageQueryHookResult = ReturnType<typeof useDesignPackageRequiredOptionsPageQuery>;
export type DesignPackageRequiredOptionsPageLazyQueryHookResult = ReturnType<typeof useDesignPackageRequiredOptionsPageLazyQuery>;
export type DesignPackageRequiredOptionsPageSuspenseQueryHookResult = ReturnType<typeof useDesignPackageRequiredOptionsPageSuspenseQuery>;
export type DesignPackageRequiredOptionsPageQueryResult = Apollo.QueryResult<DesignPackageRequiredOptionsPageQuery, DesignPackageRequiredOptionsPageQueryVariables>;
export const DesignPackageRequiredOptionsPage_AddOnsDocument = gql`
    query DesignPackageRequiredOptionsPage_AddOns($designPackageId: ID!, $designPackageVersionId: ID!) {
  designPackage(id: $designPackageId, versionId: $designPackageVersionId) {
    id
    potentialAddOnOptions {
      ...DesignPackageRequiredOptionsPage_AddOns
    }
  }
}
    ${DesignPackageRequiredOptionsPage_AddOnsFragmentDoc}`;

/**
 * __useDesignPackageRequiredOptionsPage_AddOnsQuery__
 *
 * To run a query within a React component, call `useDesignPackageRequiredOptionsPage_AddOnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageRequiredOptionsPage_AddOnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageRequiredOptionsPage_AddOnsQuery({
 *   variables: {
 *      designPackageId: // value for 'designPackageId'
 *      designPackageVersionId: // value for 'designPackageVersionId'
 *   },
 * });
 */
export function useDesignPackageRequiredOptionsPage_AddOnsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageRequiredOptionsPage_AddOnsQuery, DesignPackageRequiredOptionsPage_AddOnsQueryVariables> & ({ variables: DesignPackageRequiredOptionsPage_AddOnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageRequiredOptionsPage_AddOnsQuery, DesignPackageRequiredOptionsPage_AddOnsQueryVariables>(DesignPackageRequiredOptionsPage_AddOnsDocument, options);
      }
export function useDesignPackageRequiredOptionsPage_AddOnsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageRequiredOptionsPage_AddOnsQuery, DesignPackageRequiredOptionsPage_AddOnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageRequiredOptionsPage_AddOnsQuery, DesignPackageRequiredOptionsPage_AddOnsQueryVariables>(DesignPackageRequiredOptionsPage_AddOnsDocument, options);
        }
export function useDesignPackageRequiredOptionsPage_AddOnsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageRequiredOptionsPage_AddOnsQuery, DesignPackageRequiredOptionsPage_AddOnsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageRequiredOptionsPage_AddOnsQuery, DesignPackageRequiredOptionsPage_AddOnsQueryVariables>(DesignPackageRequiredOptionsPage_AddOnsDocument, options);
        }
export type DesignPackageRequiredOptionsPage_AddOnsQueryHookResult = ReturnType<typeof useDesignPackageRequiredOptionsPage_AddOnsQuery>;
export type DesignPackageRequiredOptionsPage_AddOnsLazyQueryHookResult = ReturnType<typeof useDesignPackageRequiredOptionsPage_AddOnsLazyQuery>;
export type DesignPackageRequiredOptionsPage_AddOnsSuspenseQueryHookResult = ReturnType<typeof useDesignPackageRequiredOptionsPage_AddOnsSuspenseQuery>;
export type DesignPackageRequiredOptionsPage_AddOnsQueryResult = Apollo.QueryResult<DesignPackageRequiredOptionsPage_AddOnsQuery, DesignPackageRequiredOptionsPage_AddOnsQueryVariables>;
export const DesignPackageRequiredOptionsPage_CombinationsDocument = gql`
    query DesignPackageRequiredOptionsPage_Combinations($dpId: ID!, $rpavId: ID!, $targetGroupIds: [ID!]!) {
  designPackage(id: $dpId, versionId: $rpavId) {
    id
    combinations(optionGroupIds: $targetGroupIds) {
      ...DesignPackageRequiredOptionsPage_Combinations
    }
  }
}
    ${DesignPackageRequiredOptionsPage_CombinationsFragmentDoc}`;

/**
 * __useDesignPackageRequiredOptionsPage_CombinationsQuery__
 *
 * To run a query within a React component, call `useDesignPackageRequiredOptionsPage_CombinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageRequiredOptionsPage_CombinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageRequiredOptionsPage_CombinationsQuery({
 *   variables: {
 *      dpId: // value for 'dpId'
 *      rpavId: // value for 'rpavId'
 *      targetGroupIds: // value for 'targetGroupIds'
 *   },
 * });
 */
export function useDesignPackageRequiredOptionsPage_CombinationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageRequiredOptionsPage_CombinationsQuery, DesignPackageRequiredOptionsPage_CombinationsQueryVariables> & ({ variables: DesignPackageRequiredOptionsPage_CombinationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageRequiredOptionsPage_CombinationsQuery, DesignPackageRequiredOptionsPage_CombinationsQueryVariables>(DesignPackageRequiredOptionsPage_CombinationsDocument, options);
      }
export function useDesignPackageRequiredOptionsPage_CombinationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageRequiredOptionsPage_CombinationsQuery, DesignPackageRequiredOptionsPage_CombinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageRequiredOptionsPage_CombinationsQuery, DesignPackageRequiredOptionsPage_CombinationsQueryVariables>(DesignPackageRequiredOptionsPage_CombinationsDocument, options);
        }
export function useDesignPackageRequiredOptionsPage_CombinationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageRequiredOptionsPage_CombinationsQuery, DesignPackageRequiredOptionsPage_CombinationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageRequiredOptionsPage_CombinationsQuery, DesignPackageRequiredOptionsPage_CombinationsQueryVariables>(DesignPackageRequiredOptionsPage_CombinationsDocument, options);
        }
export type DesignPackageRequiredOptionsPage_CombinationsQueryHookResult = ReturnType<typeof useDesignPackageRequiredOptionsPage_CombinationsQuery>;
export type DesignPackageRequiredOptionsPage_CombinationsLazyQueryHookResult = ReturnType<typeof useDesignPackageRequiredOptionsPage_CombinationsLazyQuery>;
export type DesignPackageRequiredOptionsPage_CombinationsSuspenseQueryHookResult = ReturnType<typeof useDesignPackageRequiredOptionsPage_CombinationsSuspenseQuery>;
export type DesignPackageRequiredOptionsPage_CombinationsQueryResult = Apollo.QueryResult<DesignPackageRequiredOptionsPage_CombinationsQuery, DesignPackageRequiredOptionsPage_CombinationsQueryVariables>;
export const SaveDesignPackageRequiredOptionsDocument = gql`
    mutation SaveDesignPackageRequiredOptions($input: [SaveReadyPlanRequiredOptionInput!]!) {
  saveReadyPlanRequiredOptions(input: $input) {
    readyPlanRequiredOptions {
      id
      readyPlan {
        id
        aggregateLatest {
          id
        }
      }
    }
  }
}
    `;
export type SaveDesignPackageRequiredOptionsMutationFn = Apollo.MutationFunction<SaveDesignPackageRequiredOptionsMutation, SaveDesignPackageRequiredOptionsMutationVariables>;

/**
 * __useSaveDesignPackageRequiredOptionsMutation__
 *
 * To run a mutation, you first call `useSaveDesignPackageRequiredOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDesignPackageRequiredOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDesignPackageRequiredOptionsMutation, { data, loading, error }] = useSaveDesignPackageRequiredOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDesignPackageRequiredOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDesignPackageRequiredOptionsMutation, SaveDesignPackageRequiredOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDesignPackageRequiredOptionsMutation, SaveDesignPackageRequiredOptionsMutationVariables>(SaveDesignPackageRequiredOptionsDocument, options);
      }
export type SaveDesignPackageRequiredOptionsMutationHookResult = ReturnType<typeof useSaveDesignPackageRequiredOptionsMutation>;
export type SaveDesignPackageRequiredOptionsMutationResult = Apollo.MutationResult<SaveDesignPackageRequiredOptionsMutation>;
export type SaveDesignPackageRequiredOptionsMutationOptions = Apollo.BaseMutationOptions<SaveDesignPackageRequiredOptionsMutation, SaveDesignPackageRequiredOptionsMutationVariables>;